import { ThemeProvider } from '@emotion/react';
import * as React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ErrorBoundary } from '../error/ErrorBoundary';
import { theme } from '../theme/theme';

interface AppProvidersProps {
  children: React.ReactNode;
}

export const AppProviders = (props: AppProvidersProps) => {
  const queryClient = new QueryClient({
    defaultOptions: { queries: { useErrorBoundary: true }, mutations: { useErrorBoundary: true } },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <ErrorBoundary>{props.children}</ErrorBoundary>
      </ThemeProvider>
    </QueryClientProvider>
  );
};
